// Diff-note rendering, beside the review rather than in it: a module that
// exports both a component and a helper cannot be hot-replaced.

import type { ReactNode } from "react";

/**
 * The server writes backtick-delimited spans into diff notes (`adds field
 * \`arena_rank\` · int`); render those as inline code. Splitting on a captured
 * group puts the delimited spans on the odd indices.
 */
export function renderNote(note: string): ReactNode {
  return note
    .split(/`([^`]+)`/)
    .map((part, i) => (i % 2 === 1 ? <code key={i}>{part}</code> : part));
}
